<template>
	<div>
		<span v-if="file!=''" class="file-name">{{file}}</span>
		<el-upload class="avatar-uploader" :action="config.apiurl + '/api/common/upload'" :show-file-list="false" :on-success="upAS" :before-upload="upABS" align="left">
			<el-button size="small" type="primary">{{uploadfile!=''?'重新上传':'点击上传'}}</el-button>
		</el-upload>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				file: ''
			}
		},
		methods:{
			upAS(res, file) {
				var o=document.createElement('input');
				o.input=()=>{
					this.$emit('input', res.data.url);
				}
				o.input();
				this.file=file.name;
			},
			upABS(file) {
				const isLt2M = file.size / 1024 / 1024 < 10;
				if (!isLt2M) {
					this.message({ message: '上传文件大小不能超过 10MB!', type: 'error' });
				}
				return isLt2M;
			}
		},
		props: {
			value: {
				type: String,
				default: ''
			}
		},
		mounted: function () {
			
		},
		computed:{
			uploadfile(){
				if(this.value=='')
				{
					this.file='';
				}
				return this.value;
			}
		}
	}
</script>

<style scoped>
	.avatar-uploader{
		width: 100px;
		float: left;
	}
	.file-name{
		float: left;
		padding: 0px 15px;
	}
</style>
